'use strict';

var countrySelector = require('base/components/countrySelector');

var exportCountrySelector = $.extend({}, countrySelector, {
    countrySelectorDropdown: function () {
        var countryDropdown = $('.country-selector').children('.dropdown-menu');

        $('.country-selector').on('mouseenter', function () {
            $(this).addClass('show');
            countryDropdown.addClass('show');
            setTimeout(function () {
                if ((countryDropdown).hasClass('show')) {
                    countryDropdown.addClass('trigger-active');
                }
            }, 150);
        }).on('mouseleave', function () {
            $(this).removeClass('show');
            countryDropdown.removeClass('trigger-active');
            setTimeout(function () {
                countryDropdown.removeClass('show');
            }, 250);
        });
    }
});

module.exports = exportCountrySelector;
